import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import _ from 'lodash';
import * as userApi from '../../../../lib/api/user';

//https://javascript.plainenglish.io/how-to-use-the-autocomplete-component-in-material-ui-11a7132d2b71
const EmpSelectbox = ({ formik, name, label, variant, margin }) => {
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await userApi.getUsers();
      setOptions(response.data.list);
    }

    fetchMyAPI();
  }, []);

  useEffect(() => {
    if (options.length > 0) {
      if (
        formik.values[name] !== null &&
        formik.values[name] !== '' &&
        formik.values[name] !== undefined
      ) {
        const selected = _.find(
          options,
          (item) => item.usrUuid === formik.values[name],
        );
        console.log(selected, 'selected');
        setSelectedEmp(selected);
      }
    }
  }, [options, formik.values[name]]);

  return (
    <Autocomplete
      disablePortal
      id={name} //필수
      options={options || []} //필수
      getOptionLabel={(option) => option.usrNm + ' ' + option.gradeNm}
      value={selectedEmp} //자동완성의 값
      onChange={(_event, newEmp) => {
        setSelectedEmp(newEmp);
        formik.setFieldValue(name, newEmp?.usrUuid);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin={margin}
          variant={variant}
          label={label}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
        />
      )}
    />
  );
};

export default EmpSelectbox;
